let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gpMCn")).then(() => parcelRequire('emSF0'));